var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercent = function SvgPercent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF0851",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11 11h.013M19 19h.013m1.32-9.333L9.667 20.333m2-9.333a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0m8 8a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0m8.666-4c0 7.364-5.97 13.333-13.333 13.333S1.667 22.363 1.667 15 7.637 1.667 15 1.667 28.333 7.637 28.333 15"
  })));
};
export default SvgPercent;